<template>
  <div>
    <div v-if="!mostrarFormulario">
    <div class="d-flex justify-content-center w-100 mt-4">
      <div class="busqueda d-flex mt-4" style="width: 50%; margin-top: 10px;" >
        <b-form-input class="input-filter" v-model="filter" placeholder="Búsqueda por nombre de usuario" type="text"></b-form-input>
        <b-button class="btn-extra-small" variant="info" pill>
          <span><em class="buscar_svg" style="margin-top: 3px; height: 13px; border-radius: 20px;"></em></span>
        </b-button>
      </div>
      <div class="mt-4 ml-2" >
        <b-button pill variant="primary" style="background-color: #1B81AF"
                  @click="ocultarMostrarFormulario()"
                  v-b-tooltip.hover.topright.v-light
                  title="Crear nuevo usuario"
        >
          <em class="usuario icon-boton"
              style="height: 22px; border-radius: 20px; cursor: pointer"
          ></em>
        </b-button>
      </div>
    </div>

    <div class="col-12 mt-5">
      <b-row class="contenedorTablaSinColor">
        <b-col sm="12" md="12" lg="12">
          <b-table
              id="labs"
              class="parrafos"
              fixed
              :fields="headersTabla"
              caption-top
              :items="usuariosLabProps"
              :current-page="paginaActual"
              responsive
              thead-tr-class="columnasTablaSinColor"
              :per-page="$registrosPorPaginaTabla"
              :filter="filter"
          >
            <template #cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion | formatoFechaCorta }}
            </template>
            <template #cell(Acciones)="row">
              <div class="text-center">

                <em v-if="row.item.registroActivo " class= "edit_outline_svg" style="width: 21px; cursor: pointer"
                    @click="editarLab(row.item);"
                    v-b-tooltip.hover.topleft.v-light
                    title="Editar"
                ></em>
                <em v-else class= "activar_kit" style="width: 21px; cursor: pointer"
                    @click="cambiarEstatus(row.item)"
                ></em>

                <em  v-if="row.item.registroActivo " class= "trash_svg" style="margin-left: 4px; cursor: pointer"
                     v-b-tooltip.hover.topright.v-light
                     title="Inactivar"
                     @click="cambiarEstatus(row.item)"
                ></em>
              </div>
            </template>
          </b-table>
          <b-pagination
              v-if="usuariosLabProps.length > $registrosPorPaginaTabla"
              align="center"
              v-model="paginaActual"
              :total-rows="usuariosLabProps.length"
              :per-page="$registrosPorPaginaTabla"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

  </div>

    <div v-if="mostrarFormulario">

      <div class="ml-1">
        <div class="d-flex ml-3">
          <em class="flecha_atras_svg"
              style="color: #044169; filter: brightness(0.5); cursor: pointer"
              @click="ocultarMostrarFormulario(1)"/>
          <span style="color: #676767; font-size: 11px; font-weight: 500;"> Usuarios / </span>
          <span style="color: #0155A7; font-size: 11px; font-weight: 500;"> Crear nuevo usuario </span>
        </div>

        <b-tabs v-model="indTab" nav-class="border-0" class="md-transparent mt-1 ml-1" >
          <template v-for="(pest, index) in pestaniasUsers" >
            <b-tab lazy
                   title-link-class="border-0"
                   style="font-size: 14px;"
                   :key="pest.id"
                   :title="pest.nombre"
                   v-if=" pest.permiso !== undefined
                            ? $localStorageService.can(pest.permiso)
                            : true  "
                   class="borderGray paddingTab"
            >
              <template #title >
              <span  style="font-size: 11px; pointer-events: none;cursor: default;"
                     :style="indTab === index ? 'color: #0069A9;' : 'color: #212121;  '"
              >{{ pest.nombre }} </span>
                <div v-if="indTab === index" class="linea"></div>
              </template>
            </b-tab>
          </template>
        </b-tabs>

        <span class="ml-4" style="color: #53BACA; font-size: 11px; font-weight: 500;"> Información general </span>

          <b-row class="mt-2 ml-2" v-if="indTab === 0">
            <b-col cols="5" >
                <span class="textForm">Nombre(s) <span style="color: red">*</span></span>
                <b-form-input
                    style="width: 80%"
                    class="tamanioCampo"
                    placeholder="Ingresa el nombre"
                    v-model="usuario.nombre"
                    type="text"
                    :state=" usuario.nombre != null && usuario.nombre !== '' "
                    required
                ></b-form-input>
              <br/>
              <span class="textForm">Apellido Materno <span style="color: red">*</span></span>
              <b-form-input
                  style="width: 80%"
                  class="tamanioCampo"
                  placeholder="Ingresa el apellido materno"
                  v-model="usuario.apellidoMaterno"
                  type="text"
                  :state=" usuario.apellidoMaterno != null && usuario.apellidoMaterno !== '' "
                  required
              ></b-form-input>
              <br/>
              <span class="textForm">Nombre usuario <span style="color: red">*</span></span>
              <b-form-input
                  :disabled="edicionUser"
                  style="width: 80%; text-transform: none !important;"
                  class="tamanioCampo"
                  placeholder="Ingresa el nombre de usuario"
                  v-model="usuario.nombreUsuario"
                  type="text"
                  :state=" usuario.nombreUsuario != null && usuario.nombreUsuario !== '' "
                  required
              ></b-form-input>
            </b-col>

            <b-col>
              <span class="textForm">Apellido Paterno<span style="color: red">*</span></span>
              <b-form-input
                  style="width: 80%"
                  class="tamanioCampo"
                  placeholder="Ingresa el apellido paterno"
                  v-model="usuario.apellidoPaterno"
                  type="text"
                  :state="usuario.apellidoPaterno != null && usuario.apellidoPaterno !== '' "
                  required
              ></b-form-input>
              <br/>
              <span class="textForm">Correo electronico<span style="color: red">*</span></span>
              <b-form-input
                  :disabled="edicionUser"
                  style="width: 80%"
                  class="tamanioCampo"
                  placeholder="Ingresa el correo "
                  v-model="usuario.email"
                  type="email"
                  :state="emailState"
                  required
              ></b-form-input>
              <br/>
              <span class="textForm">Contraseña <span style="color: red" v-if="usuario.idUsuario === null">*</span></span>
              <div class="d-flex contenedorContrasena" v-if="usuario.idUsuario === null">
                <b-form-input
                    style="width: 75%; text-transform: none !important;"
                    class="contenedorInputs__input fade-in"
                    placeholder="Ingresa la contraseña"
                    v-bind:class="showPassword ? 'color: #000000;': 'color: #E7E7E7;'"
                    v-model="usuario.contrasenia"
                    :type="showPassword ? 'text' : 'password'"
                    :state="usuario.contrasenia != null && usuario.contrasenia !== '' "
                ></b-form-input>
                <div class="mt-3 ml-3 contenedorContrasena__icon">
                  <b-icon @click="togglePasswordVisibility"
                          :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon>
                </div>
              </div>
              <div class="d-flex contenedorContrasena" v-else>
                <b-form-input
                    style="width: 75%; text-transform: none !important;"
                    class="contenedorInputs__input fade-in"
                    placeholder="Ingresa una nueva contraseña temporal"
                    v-model="usuario.contrasenia"
                    :type="showPassword ? 'text' : 'password'"
                ></b-form-input>
                <div class="mt-3 ml-3 contenedorContrasena__icon">
                  <b-icon @click="togglePasswordVisibility"
                          :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon>
                </div>
              </div>
              <contrasenia-validacion-robusta
                  :contrasenia.sync="usuario.contrasenia"
                  @cumpleCondicionesPassword ="cumpleCondicionesPassword = $event"
              ></contrasenia-validacion-robusta>
            </b-col>
        </b-row>

        <div v-if="indTab === 1">
          <span class="ml-4" style="color: #5A5A5A; font-size: 10px !important;">Selecciona qué permisos tiene el usuario al ver una ODT</span>
          <b-row class="mt-3 ml-2" >

            <b-col cols="2">
              <div class="mt-2">
                <span class="mt-5">PORTAL_LAB_ADMIN</span>
              </div>
              <div class="mt-3">
                <span >PORTAL_LAB_EDICION</span>
              </div>
              <div class="mt-3">
                <span >PORTAL_LAB_CONSULTA</span>
              </div>

            </b-col>
            <b-col cols="8">
              <div class="d-flex mt-2">
               <b-form-checkbox v-model="usuario.portalLabAdmin" name="check-button"

                                @input="validarUnSoloCampo(1, usuario.portalLabAdmin)"/>
                <i style="color: #5A5A5A; font-size: 10px">
                Puede realizar todas las acciones en las ordenes de trabajo y gestionar usuarios.
                </i>
              </div>
              <div class="d-flex mt-3">
               <b-form-checkbox v-model="usuario.portalLabEdicion" name="check-button"

                                @input="validarUnSoloCampo(2, usuario.portalLabEdicion)"/>
                <i style="color: #5A5A5A; font-size: 10px">
                Puede realizar todas las acciones en las ordenes de trabajo.
                </i>
              </div>
              <div class="d-flex mt-3">
                <b-form-checkbox v-model="usuario.portalLabConsulta" name="check-button"

                                 @input="validarUnSoloCampo(3, usuario.portalLabConsulta)"/>
                <i style="color: #5A5A5A; font-size: 10px">
                Puede ver las ordenes de trabajo pero sin realizar acciones.
                </i>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="text-center mt-4">
        <b-button variant="outline-primary" pill size="sm"
                  style="font-size: 10px"
                  @click="guardarUsuario()"
                  :disabled=" guardando || ( (usuario.nombre === null || usuario.nombre === '')
                   || (usuario.apellidoMaterno === null || usuario.apellidoMaterno === '')
                   || (usuario.apellidoPaterno === null || usuario.apellidoPaterno === '')
                   || (usuario.email === null || usuario.email === '')
                   || (usuario.nombreUsuario === null || usuario.nombreUsuario === '')
                   || (usuario.portalLabAdmin === false && usuario.portalLabEdicion === false && usuario.portalLabConsulta === false) )
                   || !emailState"
        >
          <strong> Guardar usuario </strong>
          <b-spinner v-if="guardando" variant="info" small/>
        </b-button>
      </div>

    </div>


  </div>
</template>
<script>


import Swal from "sweetalert2";
import  contraseniaValidacionRobusta from '../../../../components/contrasenias/contraseniaValidacionRobusta'

export default {
  name: "UsuarioLab",
  components: { contraseniaValidacionRobusta },
  props: {
    idLaboratorio: Number,
    usuariosLabProps: Array,
  },
  data: () => ({
    filter: "",
    headersTabla: [
      {key: "idUsuario", label: "ID USUARIO", sortable: false},
      {key: "nombreUsuario", label: "Nombre Usuario", sortable: false},
      {key: "nombreCompleto", label: "Nombre Completo", sortable: false},
      {key: "fechaModificacion", label: "Fecha Modificación", sortable: false},
      {key: "usuarioModificacion", label: "Usuario Modificación", sortable: false},
      "Acciones"
    ],
    mostrarFormulario: false,
    usuario: {
      idUsuario: null,
      nombre: null,
      apellidoMaterno: null,
      nombreUsuario: null,
      apellidoPaterno: null,
      email: null,
      contrasenia: null,
      portalLabAdmin: false,
      portalLabEdicion: false,
      portalLabConsulta: false,
      idCanalsistema: 1,
    },
    pestaniasUsers: [
      { id: 1, nombre: "Información general", identificadorTab:"ig", visible: false, layoutTabla: [], /* permiso: ""*/ },
      { id: 2, nombre: "Permisos", identificadorTab:"permisos", visible: false, layoutTabla: [], /* permiso: ""*/ },
    ],
    indTab: 0,
    guardando: false,
    edicionUser: false,
    paginaActual:1,
    showPassword: false,
    cumpleCondicionesPassword: false
  }),
  created() {
    this.indTab = 0;
  },
  computed: {
    emailState() {
      // Verifica si el campo está vacío, y si no, valida el formato
      if (this.usuario.email === '') return null
      const regex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i
      return regex.test(this.usuario.email)
    }
  },
  watch: {
    mostrarFormulario(){
      this.ocultarMenu();
    }
  },
  methods: {
    editarLab(item){

      this.usuario = item;
      this.mostrarFormulario = true;
      this.edicionUser = true;
    },
    cambiarEstatus(item){

      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.$http.post(this.$api + "labs/cambiarEstatus/usuarios", item).then((response) => {
            if (response.data.data){
              this.$swal({
                icon: "success",
                text: "Se guardó correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
                onClose: () => {
                  item.registroActivo = !item.registroActivo
                  this.$emit('obtenerLaboratorios', 3);
                }
              })
            }
          }).catch((error) => {
            console.log(error.message);
            this.guardando = false;
            this.$emit('obtenerLaboratorios');
          })
        }
      })

    },
    validarUnSoloCampo(index, valor ) {

      if ( index === 1 && valor) {
        this.usuario.portalLabEdicion = false;
        this.usuario.portalLabConsulta = false;
      }
      if ( index === 2 && valor) {
        this.usuario.portalLabAdmin = false;
        this.usuario.portalLabConsulta = false;
      }
      if ( index === 3 && valor) {
        this.usuario.portalLabAdmin = false;
        this.usuario.portalLabEdicion = false;
      }
    },
    ocultarMenu(){
      this.$emit("ocultarMenu", this.mostrarFormulario);
    },
    guardarUsuario(){
      if (!this.emailState) {
        Swal.fire("Aviso", "Por favor ingresa un correo válido", "info");
      } if ((this.usuario.idUsuario === null && (this.usuario.contrasenia === null || this.usuario.contrasenia === '') && this.cumpleCondicionesPassword === false) ||
          this.usuario.contrasenia != null && this.usuario.contrasenia != '' && this.cumpleCondicionesPassword === false) {
        Swal.fire("Aviso", "Asegúrate de que tu contraseña cumpla con los criterios de seguridad requeridos", "info");
      } else {
        this.usuario.idLaboratorio = this.idLaboratorio;

        this.$swal.fire({
          icon: "warning",
          html: '<p><strong>¿Estás seguro?</strong></p>',
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          confirmButtonColor: "#EEBA6D",
          preConfirm: () => {
            this.guardando = true
            this.$http.post(this.$api + "labs/guardar/usuarios", this.usuario)
                .then((resp) => {
                  console.info(resp)
                  this.$swal({
                    icon: "success",
                    text: "Se guardó correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                    onClose: () => {
                      this.$emit('obtenerLaboratorios', 4);
                    }
                  })
                }).finally(() => {
                  this.guardando = false
                }).catch(() => {
                  this.guardando = false
                })
          }
        })


    }
  },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    ocultarMostrarFormulario(tipo){
      if(tipo === 1){
        this.usuario =  {
          idUsuario: null,
          nombre: null,
          apellidoMaterno: null,
          nombreUsuario: null,
          apellidoPaterno: null,
          email: null,
          contrasenia: null,
          portalLabAdmin: false,
          portalLabEdicion: false,
          portalLabConsulta: false,
          idCanalsistema: 1
        };
      }
      this.edicionUser = false;
      this.mostrarFormulario = !this.mostrarFormulario;
    }

  }
}
</script>


<style scoped>
  .textForm {
    font-size: 10px;
    color: #7A7A7A;
    font-weight: 500;
  }
  .linea {
    border-top: 2px solid #0069A9 !important;
    height: 2px;
    max-width: 60px;
    padding: 0;
    margin: auto;
    background-color: white;
  }
  .b-tabs {
    pointer-events: none;
  }
  .icon-boton {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%)

  }
  .busqueda {
    border-width: 1px;
    border-style: solid;
    border-color: #c2e7ff;
    background: #ffffff;
    margin-top: 20px;
    margin-left: 4%;
    padding-right: 2%;
    padding-left: 1%;
    border-radius: 20px;
    text-align: left;
    align-items: center;
  }
  .inputSpace{
    margin-right: 6%;
  }

  .fade-in {
    -webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  }

  .contenedorInputs__input {
    border-radius: 0px !important;
    background-color: transparent !important;
    border: none !important;
    border-bottom: 0.1em solid #d2d2d2 !important;
    height: 50px !important;
    display: flex;
    justify-content: center;
  }
  .contenedorContrasena{
    width: 100%;
    margin-left: 0.5rem;
  }
</style>
